import { BookingEnginePaymentCardRequirement, ConfigurationFieldFlag, TextKey } from '@mews-distributor/common';
import {
    BookingEngineTaxMessage,
    GeneralServiceDocumentType as ServiceDocumentType,
} from '@mews-distributor/data-access';
import { ThemeVariant } from './components/service/ThemeWrapper';

export * from './defaultLanguage';
export * from './defaultCurrency';

export const DEFAULT_CONFIGURATION = {
    app: {
        productName: 'distributor',
        clientName: 'Mews Distributor',
        versionHash: null,
        environment: 'production',
        platformPrimaryUrl: 'https://app.mews.com',
        platformApiUrl: 'https://api.mews.com',
        bookingEngineGraphQLUrl: null,
        scriptOriginUrls: ['https://apps.mews.com/distributor/release'],
        assetBaseUrl: 'https://apps.mews.com/distributor/release/develop',
        imageBaseUrl: 'https://mews-prod.azureedge.net',
        sentryDsn: null,
        isStandalone: false,
        isIframed: false,
        cookieFirstToken: null,
        launchDarklyToken: null,
        gainsightToken: null,
        debug: false,
        pciProxyScriptUrl: 'https://pay.sandbox.datatrans.com/upp/payment/js/datatrans-inline-1.0.0.js',
        pciProxySecureFieldsScriptUrl: 'https://pay.sandbox.datatrans.com/upp/payment/js/secure-fields-2.0.0.min.js',
        applicationInsightsInstrumentationKey: null,
        newRelic: {
            eventEndpoint: null,
            insertKey: null,
            logEndpoint: null,
        },
    },
    settings: {
        hotelIds: [],
        configurationIds: [],
        startDateOffset: null,
        endDateOffset: null,
        googleTagManagerContainerId: null,
        introVideoSrc: null,
        displayVoucherCode: true,
        cancellationOffset: null,
        includeEmailInPurchaseEvent: false,
        allowAfterMidnightReservations: false,
    },
    hotels: {},
    theme: {
        variant: 'Light' satisfies ThemeVariant,
        primaryColor: null,
    },
};

export const DEFAULT_ADULT_COUNT = 2;
export const DEFAULT_CHILD_COUNT = 0;

export const DEFAULT_HOTEL_CONFIGURATION = {
    settings: {
        bookerReservationCustomerEmailInput: ConfigurationFieldFlag.Required,
        paymentCardRequirement: BookingEnginePaymentCardRequirement.AlwaysRequired,
        configurationId: '',
        serviceId: null,
        defaultAdultCount: DEFAULT_ADULT_COUNT,
        defaultChildCount: DEFAULT_CHILD_COUNT,
        maxAdultCount: null,
        requiredFields: [],
        checkoutStatement: null,
        priceLabel: BookingEngineTaxMessage.Vat,
    },
    features: {
        specialRequestsField: true,
        displayAvailability: true,
        displayFlexibleRates: false,
        enableChildSelection: true,
        rateCompare: {
            isEnabled: false,
            competitors: ['Booking.com', 'Expedia.com', 'HRS.com'],
            competitorPriceRelativeAdjustment: 1,
            rateDescription: null,
        },
    },
};

export const ALLOWED_CUSTOM_OPTIONS = ['configurationIds', 'isStandalone', 'openElements', 'element'];

export const WEEK_LENGTH = 7;
export const ONE_DAY = 1;

export const MEWS_SUPPORT_EMAIL = 'support@mews.com';

export const SMALL_MENU_HEIGHT = `72px`;
export const MOBILE_MENU_HEIGHT = `129px`;
export const DESKTOP_MENU_HEIGHT = `129px`;

export const ERROR_COMMUNICATION_WITH_SERVER_FAILED = TextKey.ConnectionErrorMessage;
export const DEPRECATED_DOMAIN_ERROR_KEY = 'DeprecatedDomainError';
export const ERROR_REQUEST_TIMEOUT = TextKey.DistributorTimeoutErrorMessage;
export const ERROR_FATAL = TextKey.DistributorFatalErrorMessage;
export const ERROR_SESSION_EXPIRED = TextKey.DistributorSessionExpiredErrorMessage;
export const ERROR_QUOTA_EXCEEDED = TextKey.DistributorQuotaExceededErrorMessage;

export const DEFAULT_DAYS_INTERVAL = 2;

export const QUERY_PARAM_HOTEL_ID = 'mewsHotel';
export const QUERY_PARAM_RESERVATION_GROUP_ID = 'mewsReservationGroupId';
export const QUERY_PARAM_RESERVATION_IDS = 'mewsReservationIds';
export const QUERY_PARAM_PAYMENT_CARD_ID = 'mewsPaymentCardId';
export const QUERY_PARAM_PROPERTY_RETURN_URL = 'mewsPropertyReturnUrl';

// Google Analytics 4 - Session linker
export const QUERY_PARAM_GA4_LINKER = '_gl';

export const API_MAXIMUM_INTERVAL_TIME_UNITS = 370;
export const API_MAXIMUM_INTERVAL_MONTHS = 59;

export const CHECKOUT_DOCUMENT_TYPES = [ServiceDocumentType.PrivacyPolicy, ServiceDocumentType.TermsAndConditions];
